import { apiGet, apiPut } from './client';

export type OpenAiProviderSettings = {
  companyId: string;
  hasApiKey: boolean;
  enabled: boolean;
  model: 'gpt-5-mini' | 'gpt-5-nano';
  updatedAt: string | null;
};

export function getOpenAiProviderSettings(companyId: string) {
  return apiGet<OpenAiProviderSettings>(`/ai-provider/openai?companyId=${encodeURIComponent(companyId)}`);
}

export function saveOpenAiProviderSettings(data: {
  companyId: string;
  apiKey?: string;
  enabled: boolean;
  model: OpenAiProviderSettings['model'];
}) {
  return apiPut<OpenAiProviderSettings>('/ai-provider/openai', data);
}

